import { cn } from '../../lib/cn';

// Inline SVG маскот-совёнок. Мягкая оранжевая палитра, дружелюбный силуэт.
export function OwlLogo({ size = 56, className }: { size?: number; className?: string }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('block', className)}
      aria-hidden
    >
      <defs>
        <linearGradient id="owlBody" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#ffae42" />
          <stop offset="100%" stopColor="#ff6600" />
        </linearGradient>
      </defs>
      <ellipse cx="32" cy="34" rx="22" ry="24" fill="url(#owlBody)" />
      <path
        d="M12 20 L18 8 L22 20 Z"
        fill="url(#owlBody)"
        opacity="0.9"
      />
      <path
        d="M52 20 L46 8 L42 20 Z"
        fill="url(#owlBody)"
        opacity="0.9"
      />
      <circle cx="23" cy="28" r="8" fill="white" />
      <circle cx="41" cy="28" r="8" fill="white" />
      <circle cx="23" cy="29" r="3.5" fill="#2b2b2b" />
      <circle cx="41" cy="29" r="3.5" fill="#2b2b2b" />
      <circle cx="24" cy="28" r="1.2" fill="white" />
      <circle cx="42" cy="28" r="1.2" fill="white" />
      <path d="M32 33 L28 37 L32 39 L36 37 Z" fill="#2b2b2b" />
      <path
        d="M20 46 Q32 52 44 46"
        stroke="#fef2e2"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
        opacity="0.6"
      />
    </svg>
  );
}
